import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

export const TraitOffer = ({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) => {
  return (
    <svg
      aria-label="TraitOffer"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 0 16 16"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M8.00008 9.33334L0.666748 5.33334L8.00008 1.33334L15.3334 5.33334L8.00008 9.33334ZM8.00008 12L1.05008 8.21668L2.45008 7.45001L8.00008 10.4833L13.5501 7.45001L14.9501 8.21668L8.00008 12Z" />
      <path
        d="M8.00005 14.6667L1.05005 10.8834L2.45005 10.1167L8.00005 13.15L13.55 10.1167L14.95 10.8834L8.00005 14.6667Z"
        opacity="0.2"
      />
    </svg>
  )
}
